<template>
  <a-modal
    :title="'AI變裝'"
    v-model="localValue"
    :destroyOnClose="true"
    :centered="true"
    :maskClosable="true"
    :width="500"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-row>
      <a-col class="col" align="center">
        <img :src="this.vrbase.scenes[this.AITransformedSceneID].location" alt="image" class="image">
        <p v-if="Object.keys(this.vrbase.scenes[this.AITransformedSceneID].tongping).length > 0">該場景已加入對比圖</p>
        <a-checkbox v-model="isAddToTongPing" v-else>
          加入對比圖（勾選後會將生成好的圖片與原圖進行對比）
        </a-checkbox>
      </a-col>
      <a-col class="col" align="center">
        <a-button type="primary" @click="handleOk">確認</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    // completedCount: {
    //   type: Number,
    //   require: true,
    // },
    // totalGenerated: {
    //   type: Number,
    //   require: true,
    // },
    // percent: {
    //   type: Number,
    //   require: true,
    // }
    handleAddTongPing: {
      type: Function,
      require: true
    },
    AITransformedSceneID: {
      type: String,
      require: true
    }
  },
  computed: {
    ...mapGetters(['vrbase']),
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
    // generateQuantityDisplay() {
    //   return `第${this.completedCount}/${this.totalGenerated}張圖片`;
    // },
    // totalMinutes(){
    //   return (this.totalGenerated - this.completedCount)*5
    // }
  },
  data() {
    return {
      isAddToTongPing: false
    }
  },
  methods: {
    handleCancel() {
      this.localValue = false;
    },
    handleOk() {
      console.log('AITransformedSceneID:', this.AITransformedSceneID);
      console.log('this.vrbase:', this.vrbase);
      if(this.isAddToTongPing && Object.keys(this.vrbase.scenes[this.AITransformedSceneID].tongping).length === 0){
        if (
          this.vrbase.scenes[this.AITransformedSceneID].pid == 'pano_27c4948ab1b2f018' 
          || this.vrbase.scenes[this.AITransformedSceneID].pid == 'pano_4896d4d222ea3670' 
        ){
          this.handleAddTongPing(this.AITransformedSceneID, this.vrbase.scenes['scene_1aaad70e2ec93ce2'] || this.vrbase.scenes['scene_b44ec47d40d0f554']);
        }
        if (
          this.vrbase.scenes[this.AITransformedSceneID].pid == 'pano_5dab7bf6ee0eeff3' 
          || this.vrbase.scenes[this.AITransformedSceneID].pid == 'pano_87c87c4b4bb20621' 
        ){
          this.handleAddTongPing(this.AITransformedSceneID, this.vrbase.scenes['scene_b97d16b9577894f7'] || this.vrbase.scenes['scene_d8eb2b25bb6f7206']);
        }
      }
      this.localValue = false;
    }
  },
}
</script>
<style lang="less" scoped>
.progress-bar {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 10px;
}

.progress {
  height: 20px;
  background-color: #015c61;
  transition: width 0.1s;
}

.image{
  object-fit: contain;
  aspect-ratio: 1;
  width: 100%;
  max-height: 315px;
}
</style>